const COMPONENT_NAMES = Object.freeze({
  MAIN: 'MainCardComponent',
  SECONDARY: 'SecondaryCardComponent',
  THIRD: 'ThirdCardComponent',
  FORTH: 'FourthCardComponent',
});

export default COMPONENT_NAMES;
